import XLSX from 'xlsx'
import AepsPool from './AepsPool';
import DataLoading from './DataLoading'


// La config pour le XLSX des relations
let RELATIONS_ROWSCOLS = {
  INDICATOR_ID_ROW: 1, // index de la ligne des indId (num ligne - 1)
  AEP_ID_COL: 1, // index de la colonne des AepId (num col - 1)
  NB_COLS_TO_DEL: 3, // nb de cols à suppr pour ne garder que les datas
  NB_ROWS_TO_DEL: 2 // nb de lignes a suppr pour ne garder que la data
}


// NOTE recalcul de la taille de la sheet, car une erreur d'excel
// lui a donné une taille gigantesque et ca faisait des out of memory
function update_sheet_range(ws) {
  var range = {s:{r:20000000, c:20000000},e:{r:0,c:0}};
  Object.keys(ws).filter(function(x) { return x.charAt(0) !== "!"; }).map(XLSX.utils.decode_cell).forEach(function(x) {
    range.s.c = Math.min(range.s.c, x.c); range.s.r = Math.min(range.s.r, x.r);
    range.e.c = Math.max(range.e.c, x.c); range.e.r = Math.max(range.e.r, x.r);
  });
  ws['!ref'] = XLSX.utils.encode_range(range);
}

class Models {
  all = {}
  init() {
    this.all = this.parseXlsxModels(DataLoading.models)
  }

  parseXlsxModels(data) {
    const relations = {}

    data.SheetNames.forEach(sn => {
      let sheet = data.Sheets[sn]

      update_sheet_range(sheet)
      let json = XLSX.utils.sheet_to_json(sheet, {header: 1})
      let IndIdsRow = json[RELATIONS_ROWSCOLS.INDICATOR_ID_ROW]
      IndIdsRow.splice(0, RELATIONS_ROWSCOLS.NB_COLS_TO_DEL) // on vire les X premières colonnes vides

      for (let i = RELATIONS_ROWSCOLS.NB_ROWS_TO_DEL; i < json.length; i++) {
        let aep_row = json[i]
        let aepId = aep_row[RELATIONS_ROWSCOLS.AEP_ID_COL]



        aep_row.splice(0, RELATIONS_ROWSCOLS.NB_COLS_TO_DEL) // on vire les x premières colonnes de titres

        aep_row.forEach((rel, colIndex) => {
          if(rel !== null) {
            if(relations[aepId] === undefined) relations[aepId] = {}
            let indId = IndIdsRow[colIndex]
            relations[aepId][indId] = rel
          }
        })
      }
    })

    return relations
  }

  applyScenario(scenario) {
    if(!scenario.models) return


    scenario.models.forEach(model => {
      let [aepIdToReplace, newId] = model
      if(newId !== null) {
        this.all[aepIdToReplace] = this.all[newId]
        AepsPool.overrideAepTitle(aepIdToReplace, newId)
        delete this.all[newId]
      }
    })
  }






  parseJsonModels(data) {
    let relations = {}


    data.forEach(d => {
      if(!relations[d.aepId]) {
        relations[d.aepId] = {}
      }
      relations[d.aepId][d.indicatorId] = d.value
    })

    return relations
  }
}


export default new Models()
